<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    import 'tailwindcss/tailwind.css';

    // CASSIOPEIA
    import { Modal, BidItem } from '@smatch/cassiopeia-web-components';

    // PAGES
    import AuctionItemPage from './pages/auction-item/AuctionItemPage.svelte';
    import AuctionFilterPage from './pages/auction-filter/AuctionFilterPage.svelte';

    // PLUGINS
    import { Router, Route } from 'svelte-navigator';

    // COMPONENTS
    import BidForm from '../bids/pages/bid-form/BidForm.svelte';
    import BidUpdate from '../bids/modules/bid-update/BidUpdate.svelte';
    import Title from 'src/app/library/title/Title.svelte';

</script>

<Title title = 'Deals' />

<!-- TODO: Fix type handling on slots / routes -->
<!-- eslint-disable @typescript-eslint/no-unsafe-member-access -->
<Router>

    <!-- TODO: Fix type handling on slots / routes -->
    <!-- eslint-disable @typescript-eslint/no-unsafe-member-access -->

    <Route path = ':key' let:params>

        <Modal hash = '#create-bid' closeOnOutsideClick = { false } let:parameters height = 'inherit'>
            <BidForm
                action = 'create'
                auctionKey = { parameters.auctionKey }
                allowsPartial = { parameters.allowsPartial }
            />
        </Modal>

        <AuctionItemPage key = { params.key } />

    </Route>

    <Modal hash = '#update-bid' closeOnOutsideClick = { false } width = '900px' let:parameters>
        <BidItem key = { parameters.key } let:bid>
            <BidUpdate { bid } />
        </BidItem>
    </Modal>

    <!-- eslint-enable -->

    <Route path = '/'>
        <AuctionFilterPage />
    </Route>

</Router>

<!-- eslint-enable -->